export const convertToTitlecase = (stringValue?: string, stopConvert?: boolean) => {
    // this stopConvert flag will use to stop conversion in specific scenario
    return stopConvert
        ? stringValue
        : stringValue?.replace(/\w\S*/g, txt => {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          });
};
